import React, { useEffect, useState, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import DetailsPage from '../components/DetailsPage';

function ParkTicketDetails() {
  const { parkId, parkName } = useParams();
  const [ticketDetails, setTicketDetails] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [totalAmount, setTotalAmount] = useState('0.00');
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const recordsPerPage = 100;

  const fetchTicketDetails = useCallback(async (pageNumber) => {
    try {
      setIsLoading(true);
      let formData = new FormData();
      formData.append('park_id', parkId);
      formData.append('page', pageNumber);
      formData.append('per_page', recordsPerPage);
      
      const response = await fetch(`${process.env.REACT_APP_API_URL}/park_reports`, {
        method: 'POST', 
        body: formData
      });
      const data = await response.json();
      if (data.code === 1) {
        if (pageNumber === 1) {
          setTicketDetails(data.report_list);
        } else {
          setTicketDetails(prevData => [...prevData, ...data.report_list]);
        }
        setTotalAmount(data.total_amount || '0.00');
        setHasMore(data.report_list.length === recordsPerPage);
      }
    } catch (error) {
      console.error('Error fetching ticket details:', error); 
    } finally {
      setIsLoading(false);
    }
  }, [parkId]);

  useEffect(() => {
    fetchTicketDetails(1);
  }, [fetchTicketDetails]);

  const handleLoadMore = () => {
    if (!isLoading && hasMore) {
      const nextPage = page + 1;
      setPage(nextPage);
      fetchTicketDetails(nextPage);
    }
  };

  const handleDateFilterChange = (startDate, endDate, filteredData) => {
    // Calculate total amount for filtered data
    const filteredTotal = filteredData.reduce((sum, row) => {
      const amount = parseFloat(row.total_price?.replace(/[^0-9.-]+/g, '')) || 0;
      return sum + amount;
    }, 0);
    setTotalAmount(filteredTotal.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
  };

  const columns = [
    { field: 'ticket_no', header: 'Ticket No' },
    { field: 'booking_date', header: 'Booking Date' },
    { field: 'customer_name', header: 'Customer Name' },
    { field: 'customer_mobile', header: 'Customer Number' },
    { field: 'ticket_price', header: 'Ticket Price' },
    { field: 'quantity', header: 'Quantity' },
    { 
      field: 'total_price', 
      header: 'Total Amount',
      render: (value) => `₹${value}`
    }
  ];

  const handleRowClick = (row) => {
    console.log('Row clicked:', row);
  };

  return (
    <DetailsPage
      title={`${parkName || 'Park'} Ticket Details`}
      backPath="/park-ticket"
      columns={columns}
      data={ticketDetails}
      onRowClick={handleRowClick}
      isLoading={isLoading}
      showTotalAmount={true}
      dateField="booking_date"
      totalAmount={totalAmount}
      onDateFilterChange={handleDateFilterChange}
      infiniteScroll={{
        hasMore,
        onLoadMore: handleLoadMore,
        loading: isLoading
      }}
    />
  );
}

export default ParkTicketDetails; 